import * as React from 'react';

import { OrganizationOwner } from '../../amorg-common';
import { fieldValidation } from '../../amorg-common';
import { updateOwner } from '../../api/organizationClientApi';
import { Button } from '../../designSystem/button/Button';
import { TextField } from '../../designSystem/formField/text/TextField';
import { txt } from '../../txt';
import { Flex } from '../../designSystem/compositeComponents/FlexHelpers';


type OrgOwnerEditorProps = {
    organizationOwner: OrganizationOwner;
    onOwnerUpdated: () => void;
    onClose: () => void;
}

export default function OrgOwnerEditor(props: OrgOwnerEditorProps): JSX.Element 
{
    const [didSubmit, setDidSubmit] = React.useState(false);
    const [owner, setOwner]  = React.useState<OrganizationOwner>({firstname:'', middlename:'', lastname:''});

    React.useEffect(()=>{
        setDidSubmit(false);
        setOwner(props.organizationOwner);
    }, [props.organizationOwner])

    async function handleSave() {
        
        setDidSubmit(true);

        if(!fieldValidation.organizationOwner.firstname(owner.firstname) ||
            !fieldValidation.organizationOwner.middlename(owner.middlename) ||
            !fieldValidation.organizationOwner.lastname(owner.lastname))

            return;

        const result = await updateOwner(owner);
        if (result.isSuccess){
            props.onOwnerUpdated();
        }
    }

    return (

        <Flex flexDirection="column" gap={16}>
            <TextField
                label="Fornavn"
                value={owner.firstname}
                onChange={value => setOwner({...owner, firstname:value})}
                validator={(currentValue)=> !didSubmit || fieldValidation.organizationOwner.firstname(currentValue)
                        ? {valid:true} 
                        : {valid:false, errorMessage:txt.fieldValidation.mandatoryText(100, currentValue)}
                } 
            />

            <TextField
                label="Mellemnavn"
                value={owner.middlename}
                onChange={value => setOwner({...owner, middlename:value})}
                validator={(currentValue)=> !didSubmit || fieldValidation.organizationOwner.middlename(currentValue)
                    ? {valid:true}
                    : {valid:false, errorMessage:txt.fieldValidation.optionalText(100, currentValue)}
                } 
            />

            <TextField
                label="Efternavn"
                value={owner.lastname}
                onChange={value => setOwner({...owner, lastname:value})}
                validator={(currentValue)=> !didSubmit || fieldValidation.organizationOwner.lastname(currentValue)
                    ? {valid:true}
                    : {valid:false, errorMessage:txt.fieldValidation.mandatoryText(100, currentValue)}
                } 
            />

            <Flex flexDirection="row" justifyContent='space-between'>
                <Button variant="text"
                    text="Annullér"
                    onClick={props.onClose} />
                <Button variant="filled"
                    text="Gem"
                    onClick={handleSave} />
            </Flex>
        </Flex>

    );
}